import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 5px 13px;
  outline: ${({ theme }) => `1px solid ${theme.colors.secondary}55`};
  border: none;
  border-radius: 5px;
  margin-top: 15px;
  width: 100%;

  label {
    position: absolute;
    left: 13px;
    line-height: 15px;
    padding: 0 4px;
    transform: translateY(-13px);
    display: inline-block;
    transition: all 0.1s ease-in-out;
    z-index: 1;
    font-size: 12px;

    &:after {
      content: "";
      background-color: ${({ theme }) => theme.colors.background};
      position: absolute;
      top: 0;
      left: -1px;
      width: calc(100% + 2px);
      height: calc(100% + 2px);
      z-index: -1;
    }
  }

  input {
    color: ${(props) => props.theme.colors.secondary};
    background: transparent;
    border: none;
    outline: none;
    font-weight: ${(props) => props.theme.fonts?.weight.regular400};
    font-size: 16px;
    min-height: 28px;
    width: 100%;

    &::placeholder {
      font-weight: ${(props) => props.theme.fonts?.weight.semiBold600};
    }
  }

  &:has(input:focus) {
    outline: ${({ theme }) => `2px solid ${theme.colors.primary}`};

    label {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;
